import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useCrudForm } from "../../api/useCrudForm";
import { endpoints } from "../../api/endpoints";
import { TablePagination } from "../../components/pagination/Pagination";
import moment from "moment";

const ContainerBox = styled(Box)`
    max-height: 100vh;
    background: white;
    padding: 20px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    overflow: hidden;
    position: relative;
    &:hover{
        overflow : auto;
    }
`;

const VisitLog = () => {

    const [vistiLogsData, setVisitLogsData] = useState<any>()
    const [count, setCount] = useState<any>(0);
    const [skip, setSkip] = useState<any>(0);
    const [take, setTake] = useState<any>(10);
    const [loading, setLoading] = useState<boolean>(false);

    const { get } = useCrudForm()

    const FetchVisitLogsData = () => {
        get({
            endpoints: `${endpoints.dashboard.visitLogs}?skip=${skip * take}&take=${take}`,
            onSuccess: (res: any) => {
                setVisitLogsData(res.data.list)
                setCount(res.data.count)
            },
            onError: (error: any) => {
                console.log(error);
            }
        })
    }

    useEffect(() => {
        setLoading(true)
        FetchVisitLogsData()
    }, [skip, take])


    return (
        <ContainerBox>
            <Box sx={{ display: "flex", gap: "20px", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" component="p" sx={{ fontWeight: 600 }}>Visit Logs</Typography>
            </Box>
            {
                vistiLogsData && vistiLogsData.map((logs: any, index: number) => (
                    <LogStatement key={index} type={logs.logStatus} id={logs.lockerNumber} checkInOutTime={logs.checkInOutTime} />
                ))
            }
            {vistiLogsData?.length > 0 || !loading ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </ContainerBox>
    );
}

const LogStatement = ({ type, id, checkInOutTime }: { type: any, id: string, checkInOutTime?: any }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Typography sx={{ fontSize: "12px" }}>
                Visit Session
                <Typography component='span' sx={{ color: `${type === "Checked In" ? "#6FCF97" : "#EB5757"}`, fontSize: "12px" }}>{" "}{type}{" "}</Typography>
                for locker no
                <Typography component="span" sx={{ fontWeight: 700, fontSize: "12px" }}>{" "}{id}{" "}</Typography>
                on {moment(checkInOutTime).format('YYYY/M/D, h:mm A')}
            </Typography>
            <Box sx={{ width: "100%", height: "2px", background: "rgba(49, 80, 161, 0.3)" }}></Box>
        </Box>
    )
}

export default VisitLog;